<template>
    <div class="admin__dashboard">
        <modal
            ref="modalName"
            :size="modalType === $options.MODAL_TYPE.TOTAL_PHOTOS  ? 'xl' : ''"
        >
            <template v-slot:header>
                <h1>{{modalTitle}}</h1>
            </template>

            <template v-slot:body>
                  <ul class="modal__list" v-if="modalType !== $options.MODAL_TYPE.TOTAL_PHOTOS">
                    <li v-for="(element) in modalContent" :key="element.id">{{element.name}}
                        <span class="modal__right__align" v-if="modalType == $options.MODAL_TYPE.TOTAL_DRIVERS_TODAY">{{element.driven}}</span>
                        <span class="modal__right__align" v-if="modalType == $options.MODAL_TYPE.TOTAL_IMPRESSIONS_TODAY">{{element.impressions}}</span>
                        <span class="modal__right__align" v-if="modalType == $options.MODAL_TYPE.TOTAL_RTIMPRESSIONS_TODAY">{{element.RT_impressions}}</span>
                        <span class="modal__right__align" v-if="modalType == $options.MODAL_TYPE.TOTAL_DISPLAYS_TODAY">{{element.displays}}</span>
                        <span class="modal__right__align" v-if="modalType == $options.MODAL_TYPE.TOTAL_DURATION_TODAY">{{element.duration}}</span>
                        <span class="modal__right__align" v-if="modalType == $options.MODAL_TYPE.DISPLAYED_CAMPAIGNS_TODAY">{{element.duration}}</span>
                    </li>
                  </ul>
                  <photos-list v-else :photos="dashboardPhotos">
                  </photos-list>
             </template>

        </modal>
        <div class="admin__dashboard__content">
            <div class="dashboard__header__container">
                <h1 class="dashboard__header">Dashboard</h1>
                <div class="dashboard__filters filters__container">
                    <div class="filters__row flex row tablet__display">
                        <div class="filter__section">
                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker", style: "width: 100px"}' v-model="filters.start_date" @input="validateOnBlur" :typeable="true"/>
                            <el-time-picker
                                v-model="filters.start_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm"
                                @input="validateOnBlur"
                                >
                            </el-time-picker>
                        </div>
                        <div class="filter__section">
                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker", style: "width: 100px"}' v-model="filters.end_date" @input="validateOnBlur" />
                            <el-time-picker
                                v-model="filters.end_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm"
                                @input="validateOnBlur" >
                            </el-time-picker>
                        </div>
                        <div class="filter__section">
                            <p class="apply-btn" @click="setDashboard">Apply</p>
                        <!--   <p class="reset-btn" @click="resetFilters">Reset</p> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="driving__container">
                <div v-if="!this.isMobile() && !this.isTablet()" class="active__driver__style">
                    <div class="active__driver__context campaign__modal"  @click="setCurrentActiveDrivers()">
                        <img src="./../../assets/active_driver.svg" alt="active driver" class="header__image">
                         <div class="box__context__text">
                            <p class="header__box">CURRENT ACTIVE DRIVERS</p>
                            <p class="header__value">{{ dashboardData.current_active_drivers }}</p>
                        </div>
                    </div>
                </div>
                <div class="box__data" v-bind:class="{ box__data__mobile: this.isMobile() || this.isTablet() }">
                    <div class="box__section__data">
                      <div v-if="this.isMobile() || this.isTablet()" class="box__style campaign__modal"  @click="setCurrentActiveDrivers()">
                            <div class="box__context">
                                <div class="eye__image__container image__container">
                                     <img src="./../../assets/active_driver.svg" alt="active driver" class="header__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" >CURRENT ACTIVE DRIVERS</p>
                                <p class="value__mini__box">{{ dashboardData.current_active_drivers }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style first__box__item">
                            <div class="box__context">

                                <div  class="driver__image__container image__container">
                                    <img src="./../../assets/total_drivers.svg" alt="total driver" class="driver__image">
                                </div>
                                 <div class="box__context__text">
                                    <p  class="name__mini__box" id="total-drivers">TOTAL DRIVERS</p>
                                    <p class="value__mini__box">{{ dashboardData.total_drivers }}</p>
                               </div>

                            </div>
                        </div>
                        <div class="box__style">
                            <div class="box__context">
                                <div class="eye__image__container image__container">
                                    <img src="./../../assets/impressions.svg" alt="total impresions" class="eye__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id="total-impressions">TOTAL IMPRESSIONS</p>
                                <p class="value__mini__box">{{ dashboardData.total_impressions }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style">
                            <div class="box__context">
                                <div class="eye__image__container eye__image__container__rt image__container">
                                    <img src="./../../assets/impressions.svg" alt="total impresions" class="eye__image">
                                    <img src="./../../assets/impressions.svg" alt="total impresions" class="eye__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id="real-time-impressions">TOTAL REAL TIME IMPRESSIONS</p>
                                <p class="value__mini__box">{{ dashboardData.total_RT_impressions }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style">
                            <div class="box__context" >
                                <div class="car__image__container image__container">
                                    <img src="./../../assets/display_count.svg" alt="car count" class="car__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id="display-count">TOTAL DISPLAY COUNT</p>
                                <p class="value__mini__box">{{ dashboardData.total_display_count }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style" v-bind:class="{ last__box__item : !this.isMobile() && !this.isTablet()}">
                            <div class="box__context">
                                <div class="time__image__container image__container">
                                    <img src="./../../assets/time_flag.svg" alt="car count" class="time__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id='display-duration'>TOTAL DISPLAY DURATION</p>
                                <p class="value__mini__box">{{ dashboardData.total_display_duration }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box__section__data box__separation">
                        <div class="box__style first__box__item">
                            <div class="box__context  campaign__modal" @click="setTotalDriversToday()">
                                <div class="driver__image__container image__container">
                                    <img src="./../../assets/total_drivers.svg" alt="total driver" class="driver__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id="total-drivers-today">TOTAL DRIVERS TODAY</p>
                                <p class="value__mini__box">{{ dashboardData.total_drivers_today }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style">
                            <div class="box__context  campaign__modal" @click="setCampaignsToday($options.MODAL_TYPE.TOTAL_IMPRESSIONS_TODAY, 'TOTAL IMPRESSIONS TODAY')">
                                <div class="eye__image__container image__container">
                                    <img src="./../../assets/impressions.svg" alt="total impresions" class="eye__image">
                                </div>
                                 <div class="box__context__text">
                                    <p class="name__mini__box" id="total-impressions-today">TOTAL IMPRESSIONS TODAY</p>
                                    <p class="value__mini__box">{{ dashboardData.total_impressions_today }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style">
                         <div class="box__context  campaign__modal"  @click="setCampaignsToday($options.MODAL_TYPE.TOTAL_RTIMPRESSIONS_TODAY,'TOTAL REAL TIME IMPRESSIONS TODAY')">
                                   <div class="eye__image__container eye__image__container__rt image__container">
                                    <img src="./../../assets/impressions.svg" alt="total impresions" class="eye__image">
                                    <img src="./../../assets/impressions.svg" alt="total impresions" class="eye__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id="real-time-impressions-today">TOTAL REAL TIME IMPRESSIONS TODAY</p>
                                <p class="value__mini__box">{{ dashboardData.total_RT_impressions_today }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style">
                          <div class="box__context  campaign__modal" @click="setCampaignsToday($options.MODAL_TYPE.TOTAL_DISPLAYS_TODAY, 'TOTAL DISPLAY COUNT TODAY')">
                                  <div class="car__image__container image__container">
                                    <img src="./../../assets/display_count.svg" alt="car count" class="car__image">
                                </div>
                                 <div class="box__context__text">
                                    <p class="name__mini__box" id='display-count-today'>TOTAL DISPLAY COUNT TODAY</p>
                                    <p class="value__mini__box">{{ dashboardData.total_display_count_today }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box__style" v-bind:class="{ last__box__item: !this.isMobile() && !this.isTablet() }">
                         <div class="box__context  campaign__modal"  @click="setCampaignsToday($options.MODAL_TYPE.TOTAL_DURATION_TODAY,'TOTAL DISPLAY DURATION TODAY')">
                                   <div class="time__image__container image__container">
                                    <img src="./../../assets/time_flag.svg" alt="car count" class="time__image">
                                </div>
                                 <div class="box__context__text">
                                <p class="name__mini__box" id="display-duration-today">TOTAL DISPLAY DURATION TODAY</p>
                                <p class="value__mini__box">{{ dashboardData.total_display_duration_today }}</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.isMobile() || this.isTablet()" class="box__style">
                            <div class="box__context  campaign__modal"  @click="setCampaignsToday($options.MODAL_TYPE.DISPLAYED_CAMPAIGNS_TODAY, 'DISPLAYED  CAMPAIGNS TODAY')">
                                  <div class="image__container">
                                    <img src="./../../assets/create_campaign.svg" alt="">
                                </div>
                                 <div class="box__context__text">
                                    <p class="name__mini__box" id='display-count-today'>AVAILABLE CAMPAIGNS</p>
                                    <p class="value__mini__box"> {{ dashboardData.available_campaigns }}</p>
                                </div>
                            </div>
                        </div>

                         <div v-if="this.isMobile() || this.isTablet()" class="box__style">
                            <div class="box__context  campaign__modal" @click="setCampaignsToday($options.MODAL_TYPE.TOTAL_PHOTOS, 'LATEST PHOTOS FROM ACTIVE DEVICES')">
                                  <div class="image__container">
                                    <img src="./../../assets/photos-icon.svg" alt="">
                                </div>
                                 <div class="box__context__text">
                                    <p class="name__mini__box" id='display-count-today'>PHOTOS</p>
                                    <p class="value__mini__box"> {{ dashboardData.photos ? dashboardData.photos.length : 0 }}</p>
                                </div>
                            </div>
                        </div>


                         <div v-if="this.isMobile() || this.isTablet()" class="box__style">
                          <div class="box__context  campaign__modal"  @click="setCampaignsToday($options.MODAL_TYPE.DISPLAYED_CAMPAIGNS_TODAY, 'DISPLAYED  CAMPAIGNS TODAY')">
                                  <div class="image__container">
                                    <img src="./../../assets/create_campaign.svg" alt="">
                                </div>
                                 <div class="box__context__text">
                                    <p class="name__mini__box" id='display-count-today'>DISPLAYED CAMPAIGNS TODAY</p>
                                    <p class="value__mini__box"> {{ dashboardData.displayed_campaigns_today }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!this.isMobile() && !this.isTablet()" class="campaign__section">
                <div class="campaign__section__box distance__campaign__box">
                    <div class="campaign__box__context  campaign__modal"  @click="setCampaignsToday($options.MODAL_TYPE.DISPLAYED_CAMPAIGNS_TODAY, 'DISPLAYED  CAMPAIGNS TODAY')">
                        <div>
                            <img src="./../../assets/create_campaign.svg" alt="">
                            <p class="campaign__box__name">AVAILABLE CAMPAIGNS</p>
                        </div>
                        <p class="campaign__box__value">
                        {{ dashboardData.available_campaigns }}</p>
                    </div>
                </div>

                <div class="campaign__section__box distance__campaign__box bottom__campaign__box" @click="setCampaignsToday($options.MODAL_TYPE.TOTAL_PHOTOS, 'LATEST PHOTOS FROM ACTIVE DEVICES')">
                    <div class="campaign__box__context  campaign__modal" >
                        <div>
                            <img src="./../../assets/photos-icon.svg" alt="">
                            <p class="campaign__box__name">PHOTOS</p>
                        </div>
                        <p class="campaign__box__value">
                        {{ dashboardData.photos ? dashboardData.photos.length : 0 }}</p>
                    </div>
                </div>


                <div class="campaign__section__box bottom__campaign__box">
                    <div class="campaign__box__context  campaign__modal" @click="setCampaignsToday($options.MODAL_TYPE.DISPLAYED_CAMPAIGNS_TODAY, 'DISPLAYED CAMPAIGNS TODAY ')">
                        <div>
                            <img src="./../../assets/display_campaign.svg" alt="">
                            <p class="campaign__box__name">DISPLAYED CAMPAIGNS TODAY </p>
                        </div>
                        <p class="campaign__box__value">{{ dashboardData.displayed_campaigns_today }}</p>
                    </div>
                </div>
            </div>

            <div class="map__section map__style">
                <span class="map__name">Map</span>
                <heatmap
                    v-if="dashboardHeatMapPoints"
                    class="dashboard-heatmap"
                    :initialPoints="dashboardHeatMapPoints"
                    :center="$options.DEFAULT_CENTER_POINT"
                    @map-promise="heatmapPromise"
                />
            </div>
            <div class="chart__section">
                <div>
                    <div class="chart__filters">
                        <p style="float: left; padding: 5px; position: absolute; left: 15px; font-weight: bold;">AVERAGE DATA AT A GLANCE</p>

                        <div class="filter data__filters" style="display: flex; position: absolute; left: 32%;">
                            <p class="filter__position" :class="{'active__chart__label': chartType === 'impressions'}" @click="setChartType('impressions')">Impressions</p>
                            <p class="filter__position" :class="{'active__chart__label': chartType === 'duration'}" @click="setChartType('duration')">Display Duration</p>
                            <p class="filter__position" :class="{'active__chart__label': chartType === 'campaigns'}" @click="setChartType('campaigns')"># Of Campaigns</p>
                            <p class="filter__position" :class="{'active__chart__label': chartType === 'cars'}" @click="setChartType('cars')"># Of Cars</p>
                        </div>

                        <div class="filter time__filters" style="display: flex; position: absolute; right: 15px;">
                            <p class="filter__position" :class="{'active__chart__label': chartDuration === 'hours'}" @click="setChartDuration('hours')">Hours</p>
                            <p class="filter__position" :class="{'active__chart__label': chartDuration === 'days'}" @click="setChartDuration('days')">Days</p>
                        </div>
                    </div>

                    <div style="position: relative;">
                        <apexchart type="line" :options="chartOptions" :series="chartSeries"></apexchart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from '@utils/Chart.js'
import styles from '@utils/mapStylesDark.js'
import {gmapApi} from 'vue2-google-maps'
import Modal from '@components/partials/Modal.vue'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import TimePicker from '@components/partials/TimePicker.vue'
import PhotosList from '@components/partials/PhotosList.vue'
import Heatmap from '@components/partials/Heatmap.vue'

const DEFAULT_CENTER_POINT = {lat: 	34.052235, lng: -118.243683};
const MODAL_TYPE = {
    TOTAL_PHOTOS: 'total_photos',
    TOTAL_DRIVERS_TODAY: 'total_drivers_today',
    TOTAL_IMPRESSIONS_TODAY :'total_impressions_today',
    TOTAL_RTIMPRESSIONS_TODAY :'total_rtimpressions_today',
    TOTAL_DISPLAYS_TODAY:'total_displays_today',
    TOTAL_DURATION_TODAY: 'total_duration_today',
    DISPLAYED_CAMPAIGNS_TODAY: 'displayed_campaigns_today',
}


export default {
    name: 'AdminDashboard',
     components: {
        Datepicker,
        TimePicker,
        Modal,
        PhotosList,
        Heatmap,
    },
    MODAL_TYPE,
    DEFAULT_CENTER_POINT,
    data: function () {
        return {
            chartType: 'impressions',
            chartDuration: 'days',
            chart: {
                days: [],
                hours: []
            },
            chartOptions: {},
            chartSeries: [],
            dashboardData: {},
            dashboardPhotos: [],
            dashboardHeatMapPoints: null,
            styles,
            map: null,
            modalContent: [],
            modalTitle: '',
            modalType: '',
            CampaignsToday: [],
            driversToday: [],
            activeDriversToday: [],
            drivers: [],
            filters: {
                start_date: moment(moment().subtract(1, 'months').format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate(),
                end_date: moment(moment().format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate(),
                start_time: '00:00:00',
                end_time: '00:00:00'
            },
            markers: [],
        }
    },
   
    methods: {
        heatmapPromise(map) {
            this.map = map;
        },
        setDashboard() {
            var url = '/admin/dashboard'

            var parsed = JSON.stringify(this.filters)
            localStorage.setItem('filters', parsed)

            var from = moment(this.filters.start_date).format("YYYY-MM-DD") + " " + this.filters.start_time
            var till = moment(this.filters.end_date).format("YYYY-MM-DD") + " " + this.filters.end_time

            var body = {
                data: {
                    from,
                    till
                }
            }

            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    this.dashboardData = {...response.data}
                     console.log('Received from api: ',response.data)

                    this.setGraphs()

                    //  const durationTotal=parseInt(this.dashboardData.total_display_duration.slice(" ")).toFixed(2);
                    //  this.dashboardData.total_display_duration=durationTotal.toString()+'hrs'

                    let objects = []
                    this.dashboardData.campaigns_today.map(function(value, key) {
                        objects.push(value);
                    });
                    this.CampaignsToday = objects
                    objects =[]
                    this.dashboardData.drivers_today.map(function(value, key) {
                        objects.push(value);
                    });
                    this.driversToday = objects
                    objects =[]
                    this.dashboardData.active_drivers.map(function(value, key) {
                        objects.push(value);
                    });
                    this.activeDriversToday = objects;

                    this.dashboardPhotos = this.dashboardData.photos;
                    if (this.map && this.dashboardData.drivers.features) {
                        this.setMap()
                    }
                } else {
                    if (response.code === 112) {
                        this.checkTokenConditions(this.setDashboard)
                    }
                }
            })

            this.fetchDashboardHeatMapPoints(from, till).then(res => {
                if (res.data) {
                    this.dashboardHeatMapPoints = res.data.points ? [res.data.points] : [];
                }
            })
        },

        fetchDashboardHeatMapPoints(from, till) {
            const url = '/admin/dashboard/maps'
            const body = {
                data: {
                    from,
                    till,
                }
            }

            return this.request(url, 'POST', body)
        },

        setGraphs() {
            var url = '/admin/dashboard/graphs'

            var from = moment(this.filters.start_date).format("YYYY-MM-DD") + " " + this.filters.start_time
            var till = moment(this.filters.end_date).format("YYYY-MM-DD") + " " + this.filters.end_time

            var body = {
                data: {
                    from,
                    till
                }
            }

            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    this.chart.days = response.data.displays_by_weekday
                    this.chart.hours = response.data.displays_by_hour
                    this.setChart()
                } else {
                    if (response.code === 112) {
                        this.checkTokenConditions(this.setGraphs)
                    }
                }
            })
        },

        setChart() {
            let categories = []
            let series = []

            this.chart[this.chartDuration].map(obj=>{
                categories.push(obj[this.chartDuration.replace("s", "")])
                series.push(obj[this.chartType])
            })

            this.chartSeries = Chart.getChartSeries("driver-chart-series", series)
            this.chartOptions = Chart.getChartOptions("driver-chart-categories", categories)
        },
        setMap() {
            let bounds = new this.google.maps.LatLngBounds()

            this.deleteMarkers()
            this.dashboardData.drivers.features.map(feature=>{

                var coordinates = feature.geometry.coordinates
            // this.dashboardData.cars.coordinates.map(coordinates=>{
                var latLng = new this.google.maps.LatLng(coordinates[1], coordinates[0])
                bounds.extend(latLng)

                var contentString = '<a href="#" target="_blank">'+feature.properties.driver_name+'</a></br><p>Active for: <span style="float: right; font-weight:bold;    margin-left: 10px;">'+feature.properties.active+'</span></p><p>Last active: <span style="float: right; font-weight:bold;    margin-left: 10px;">'+feature.properties.last_active+'</span></p><a href="'+feature.properties.picture_url+'" target="_blank">Latest picture</a>';
                let infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 200,
                });
                let marker = new this.google.maps.Marker({
                    position: latLng,
                    icon: require('../../assets/map_car.svg'),
                    map: this.map
                })
                this.markers.push(marker);

                 marker.addListener("click", () => {
                    infowindow.open( this.map, marker);
                });
            })

            this.map.fitBounds(bounds)
        },
       setMapOnAll(map) {
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(map);
            }
        },
        clearMarkers() {
            this.setMapOnAll(null);
        },
        deleteMarkers() {
            this.clearMarkers();
            this.markers = [];
        },
        setChartType (type) {
            this.chartType = type
            this.setChart()
        },
        setChartDuration (duration) {
            this.chartDuration = duration
            this.setChart()
            },
        setCurrentActiveDrivers(){

            this.modalTitle = 'CURRENT ACTIVE DRIVERS'
            this.modalType = 'current_active_drivers'

            this.modalContent = this.activeDriversToday
            this.$refs.modalName.openModal();
        },
        setTotalDriversToday(){

            this.modalTitle = 'TOTAL DRIVERS TODAY';
            this.modalType = MODAL_TYPE.TOTAL_DRIVERS_TODAY;

            this.modalContent =  this.driversToday;
            this.$refs.modalName.openModal();
        },

         setCampaignsToday(campaignType, title){

            this.modalTitle = title;
            this.modalType = campaignType;
            this.modalContent = this.CampaignsToday;
            this.$refs.modalName.openModal();

         },
         validateOnBlur(){

            if(this.filters.start_date === null) {
                  this.filters.start_date =moment(moment().subtract(1, 'months').format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate()
            }
            if(this.filters.end_date === null) {
                  this.filters.end_date = moment(moment().format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate()
            }
            if(this.filters.start_time === null) {
               this.filters.start_time ='00:00:00'
            }
            if(this.filters.end_time === null) {
               this.filters.end_time ='00:00:00'
            }
        },
        resetFilters(){

            localStorage.removeItem('filters')
            this.filters.start_date = moment(moment().subtract(1, 'months').format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate()
            this.filters.end_date = moment(moment().format('MM-DD-YYYY'), 'MM-DD-YYYY').toDate()
            this.filters.start_time ='00:00:00'
            this.filters.end_time = '00:00:00'
            this.setDashboard()
        },
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    store.commit('setToken', response.data[0])
                    store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === 112) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        }

    },
    mounted() {
        if (localStorage.getItem('filters')) {
            try {
                var deserialized = JSON.parse(localStorage.getItem('filters'))

                this.filters = deserialized
                this.filters.start_date =  new Date( deserialized.start_date)
                this.filters.end_date =  new Date( deserialized.end_date)
            } catch(e) {
            localStorage.removeItem('filters');
        }
    }

        this.setDashboard();
    },
    computed: {
        google: gmapApi,
    },

    watch: {
        map() {
            if (this.dashboardData?.drivers?.features && this.map) {
                this.setMap()
            }
        }
    }
}
</script>

<style scoped>
@import '../../style/admin.css';

.admin__dashboard {
    width: 100%;
    height: 100%;
    text-align: left;
}

.admin__dashboard__content {
    width: 100%;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 20px;
    text-align: left;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.dashboard__header {
    margin-top: 59px;
    margin-bottom: 35px;
    font-style: normal;
    font-weight: normal;
    font-size: 50px;
    line-height: 63px;
    color: #2856B8;
    float: left;
}
.el-date-editor.el-input{
    width: 130px !important;
}

.driving__container { display: flex; }

.header__box {
    margin-top: 55px;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    color: #2E2E2E;
}

.header__value {
    font-size: 70px;
    line-height: 38px;
    text-align: center;
}

.header__image {
    width: 165px;
    height: 165px;
    margin-top: 33px;
}

.active__driver__style {
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
    box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-preferred-size: 80px;
    flex-basis: 80px;
    margin: 0 10px 10px 4px;
    text-align: left;
    padding: 0 15px 0px 15px;
}

.box__style {
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
    box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-preferred-size: 80px;
    flex-basis: 80px;
    margin: 0 10px 10px 10px;
    text-align: left;
    padding: 15px 15px 15px 15px;
}

.box__data {
    display: flex;
    flex-direction: column;
}

.box__section__data{
    display: flex;
}

.campaign__section{
    display: flex;
    padding: 54px 0px 15px 0px;
    flex-direction: row;
}

.map__section{
    width: 100%;
    height: 100%;
}

.map__style {
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
    box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-preferred-size: 80px;
    flex-basis: 80px;
    margin: 54px 0px 10px 0px;
    text-align: left;
    padding: 15px 7px 15px 7px;
    width: calc(100% - 14px);
}

.chart__section{
    border-radius: 5px;
    box-shadow: rgba(15, 32, 47, 0.5) 0px 0px 10px; -moz-box-flex: 1; flex-grow: 1; flex-basis: 80px; text-align: left;
    margin-top: 54px;
}

.vue-map-container {
    width: 100%;
    margin-top: 15px;
}

.name__mini__box {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #2E2E2E;
    height: 55px;
}

.value__mini__box {
    font-size: 35px;
    line-height: 0px;
    position: relative;
    bottom: 0px;
}

.campaign__section__box {
    width: 45%;
    border-radius: 5px;
    box-shadow: rgba(15, 32, 47, 0.5) 0px 0px 10px;
    -moz-box-flex: 1;
    flex-grow: 1;
    flex-basis: 80px;
    text-align: left;
    padding: 30px 4% 25px 25px;
    position: relative;
    display: flex;
    flex-direction: row;
}

.box__context {
    width: 100%;
    height: 100%;
}

.dashboard-heatmap {
    width: 100%;
    height: 500px;
    margin-top: 23px;
}

#total-drivers { padding-top: 2px; }
#total-impressions { padding-top: 13px; }
#real-time-impressions { padding-top: 11px; }
#display-count { padding-top: 12px; }
#display-duration { padding-top: 11px; }
#total-impressions-today { padding-top: 11px; }
#real-time-impressions-today { padding-top: 10px; }
#display-count-today { padding-top: 10px; }
#display-duration-today { padding-top: 11px; }

.driver__image { width: 45px; }
.eye__image { width: 40px; }
.car__image { width: 77px; }
.time__image { width: 40px; }

.eye__image__container { padding-top: 15px; }
.car__image__container { padding-top: 13px; }

.last__box__item { margin-right: 0px; }

.box__separation { margin-top: 57px; }

.campaign__box__name {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: #2E2E2E;
}

.distance__campaign__box { margin-right: 15px; }

.campaign__box__context {
    width: 100%;
    height: 100%;
    position: relative;
}

.campaign__box__value {
    position: absolute;
    right: 24px;
    top: calc(50% - 111px);
    font-size: 66px;
}

.map__name {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    color: #0F202F;
}

.chart__filters {
    display: flex;
    position: relative;
    height: 55px;
}

.filter { display: flex; position: absolute; }
.data__filters { left: 15px; }
.time__filters { right: 15px; }

.filter__position {
    margin-right: 10px;
    padding: 5px;
    cursor: pointer;
}
.dashboard__filters{
    float:right;
    margin-top: 6%;
    margin-bottom: 35px;
}
.datepicker{
    width: 130px !important;
    max-width: 130px !important;
}
.apply-btn,.reset-btn{
    border-radius: 15px;
    background: #2EA3FF;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 15px;
    padding-right: 15px;
    color: #fff;
    height: 35px;
    margin-top: 10px;
    margin-bottom: 0px;
    width: 85px;
    cursor: pointer;
}
.reset-btn{
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    margin-left: 12px;
}
.el-input__inner{
    font-size:13px !important;
    color: #000 !important;
}
.modal__right__align{
    float: right;
    text-align: right;
}
.modal__list{
    list-style-type: none;
    padding-left: 5px;
    width: 90%;
}

.campaign__modal{
    cursor: pointer;
}



@media only screen and (max-width: 1300px) {
    .campaign__section {
        flex-direction: column;
    }

    /* .campaign__section__box {
        width: 91%;
    } */

    .campaign__section__box{
        width: 93.5%;
    }

    .bottom__campaign__box {
        margin-top: 15px;
    }

    .active__driver__style {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 15px;
    }

    .driving__container {
        flex-direction: column;
    }

    .active__driver__context {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .header__image {
        margin-top: 7px;
        margin-bottom: 7px;
    }

    .first__box__item {
        margin-left: 0;
    }

    .box__separation {
        margin-top: 15px;
    }

    .header__value {
        position: relative;
        right: 0;
    }
}

@media only screen and (max-width: 1100px) {

    .campaign__section {
        width: 100%;
    }

    /* .campaign__section__box {
        padding-right: 45px;
    } */

    .box__section__data {
        flex-wrap: wrap;
    }

    .box__style{
        min-width: 150px;
        max-width: 100%;
        max-height: 200px;
          margin-left: 10px;
        margin-right:0;
        min-height: 100px;
    }

    .chart__section {
        width: 100%;
    }
    .box__data__mobile{
        margin-left:-10px;
    }
    .box__data__mobile .last__box__item{
        margin: 0;
        margin-left:10px;
    }
    .box__data__mobile .box__context{
        display: flex;
    }


    .box__data__mobile .box__context__text p{
        text-align: left;
        font-size: 20px;
        margin: 20px;
         margin-left: 0;
        font-weight: bold;
        padding-left: 20px;
    }
    .box__data__mobile .box__context__text p:first-child{
        font-size: 90%;
        text-align: left;
        margin: 15px auto 20px 20px;
        padding-top: 0 !important;
        padding-left: 0 ;
    }

    .box__data__mobile .image__container{
        height:70px;
        width:70px;
        display:table-cell;
        vertical-align:middle;
        text-align:center;
            margin: auto 0;
    }
    .box__data__mobile .image__container img{
        display: block;
        width: 100%;
        height: 100%;
        max-height: 100%;
    }
    .box__data__mobile .eye__image__container__rt img{
        height: 40%;
    }
     .box__data__mobile .eye__image__container{
  padding-top: 0;
     }
  .el-date-editor.el-input{
         margin-right: 0
     }
  .apply-btn{
         margin: 15px auto 5px 0;
     }
    .dashboard__header{
        margin-top: 20px;
        margin-bottom: 20px;
        }

   .filter__position{

           font-size: 80%;
   }
 .dashboard__filters{
    float:left;
}
.box__separation{
    margin-top:0;
}



}

@media only screen and (min-width: 600px) and (max-width: 1024px) {
      .box__style{
            width: 30%;
        }

}
@media only screen and (min-width: 865px) and (max-width: 1024px) {

        .dashboard__filters {
            float: right;
        }
}

@media only screen and (max-width: 1230px) {
    .chart__filters {
        height: 110px;
    }

    .data__filters {
        top: 60px !important;
        left: 10px !important;
    }

    .time__filters {
        top: 60px !important;
    }
}

@media only screen and (max-width: 930px) {
    .chart__filters {
        height: 165px;
    }

    .time__filters {
        top: 110px !important;
        left: 10px !important;
    }
   .el-date-editor.el-input{
       width:70% !important;
       margin-left: 10px;
        margin-right: 10px;
    }
    .apply-btn, .reset-btn{
        width: 35% !important;
    }
}

 /* Landscape */
@media only screen
  and (min-device-width: 375px)
  and (max-device-width: 667px)
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) {

    .box__data__mobile .box__context__text p{
        font-size: 85% !important;
    }
}

@media only screen and (max-width: 828px) {
    .box__data__mobile .box__context__text p{
        font-size: 95%;
    }
     .box__data__mobile .box__context__text p:first-child{
        font-size: 70%;}
}

@media only screen and (max-width: 600px){
     .el-date-editor.el-input{
       width:100% !important;
       margin-left: 0;
       }
}
</style>
